import { FaPlus } from 'react-icons/fa';
import { useState } from 'react';
import PatientStatus from '../../images/patient_status.svg';
import PendingStatus from '../../images/Pending_status.svg';
import ActiveStatus from '../../images/Case_status.svg';
import CompletedStatus from '../../images/completed_status.svg';
import AddLawyer from '../../images/add_lawyer.svg';
import AddPhysician from '../../images/add_physician.svg';
import ReviewIncomplete from '../../images/review_incomplete.svg';
import AddPatient from '../../images/add_patient.svg';
import NewUserForm from '../../ui/panels/Forms/NewUserForm/NewUserForm';
import { useNavigate } from 'react-router-dom';

import './AdminDashboard.css';

function AdminDashboard(): JSX.Element {

  //TODO: Need API for the metadata of cases open, patient count,pending reviews etc.
  const nav = useNavigate();
  const [showNewUserForm, setShowNewUserForm] = useState<boolean>(false);
  const [token, setToken] = useState<string>(
    localStorage.getItem('token') || ''
  );

  const handleOpenNewUserForm = () => {
    setShowNewUserForm(true);
  };

  const handleCloseNewUserForm = () => {
    setShowNewUserForm(false);
  };

  return (
    <div className="admin-dashboard-container">
      <div className="admin-dashboard-head-row">
        <h2>Scribe Dashboard</h2>
        <button onClick={handleOpenNewUserForm}>
          <FaPlus className="dashboard-head-row-icon" />
          <span>ADD NEW USER</span>
        </button>
      </div>

      <div className="admin-dashboard-status-row">
        <div className="admin-dashboard-status-card">
          <div className="admin-dashboard-status-card-left">
            <p>My Patients</p>
            <h4>28</h4>                 //TODO: All the values are currently hardcoded. Need to integrate the API.
          </div>
          <div className="admin-dashboard-status-card-right">
            <img src={PatientStatus} alt="patient-status-icon" />
          </div>
        </div>

        <div className="admin-dashboard-status-card">
          <div className="admin-dashboard-status-card-left">
            <p>Active Cases</p>
            <h4>15</h4>
          </div>
          <div className="admin-dashboard-status-card-right">
            <img src={ActiveStatus} alt="patient-status-icon" />
          </div>
        </div>

        <div className="admin-dashboard-status-card">
          <div className="admin-dashboard-status-card-left">
            <p>Pending Reviews</p>
            <h4>6</h4>
          </div>
          <div className="admin-dashboard-status-card-right">
            <img src={PendingStatus} alt="patient-status-icon" />
          </div>
        </div>

        <div className="admin-dashboard-status-card">
          <div className="admin-dashboard-status-card-left">
            <p>Completed</p>
            <h4>12</h4>
          </div>
          <div className="admin-dashboard-status-card-right">
            <img src={CompletedStatus} alt="patient-status-icon" />
          </div>
        </div>
      </div>

      <div className="admin-dashboard-actions-row">
        <h4>Quick Actions</h4>
        <div className="admin-dashboard-actions-btns">
          <button>
            <img
              src={AddLawyer}
              alt="add-lawyer"
              style={{ marginRight: '10px' }}
            />
            <p>Add New Lawyer</p>
          </button>

          <button>
            <img
              src={AddPatient}
              alt="add-lawyer"
              style={{ marginRight: '10px' }}
            />
            <p>Add New Patient</p>
          </button>

          <button>
            <img
              src={ReviewIncomplete}
              alt="add-lawyer"
              style={{ marginRight: '10px' }}
            />
            <p>Review In-Complete Cases</p>
          </button>

          <button>
            <img
              src={AddPhysician}
              alt="add-physician"
              style={{ marginRight: '10px' }}
            />
            <p>Add New Physician</p>
          </button>
        </div>
      </div>

      <div className="admin-dashboard-recent-activity">
        <h4>Recent Activities</h4>
      </div>

      {showNewUserForm && (
        <NewUserForm
          token={token}
          nav={nav}
          handleCloseFormPressed={handleCloseNewUserForm}
        />
      )}
    </div>
  );
}

export default AdminDashboard;
